import { Crud, HttpClient, httpClient, QueryParameter, RequestOptions } from 'lib/HttpClient';
import { IAwardEnrichment } from './models/AwardEnrichment';
import { DEFAULT_PAGE_LIMIT } from 'lib/hooks/usePagedData';

const DEFAULT_QUERY_PARAMS: QueryParameter[] = [{ key: 'limit', value: DEFAULT_PAGE_LIMIT.toString() }];

class AwardEnrichmentApi extends Crud {
    constructor(client: HttpClient) {
        super(client, process.env.API_SERVER_URL, 'awardenrichments');
    }

    async getAllAwardEnrichments() {
        let nextKey: string;
        let endOfData = false;
        let loadedAwards: IAwardEnrichment[] = [];
        let ok = true;

        while (!endOfData) {
            try {
                const query: QueryParameter[] = nextKey
                    ? [{ key: 'startKey', value: nextKey }, ...DEFAULT_QUERY_PARAMS]
                    : DEFAULT_QUERY_PARAMS;

                const res = await this.getList({ queryParameters: query });

                if (!res.ok || !res.body.items) {
                    throw new Error(res.body.message);
                }

                const {
                    items: awards,
                    page: { nextKey: nextKeyFromResponse }
                } = res.body;

                loadedAwards = [
                    ...loadedAwards,
                    ...awards.map((item: IAwardEnrichment) => ({ ...item, id: item._id }))
                ];

                nextKey = nextKeyFromResponse;

                if (!nextKey) {
                    endOfData = true;
                }
            } catch (err) {
                endOfData = true;
                ok = false;
            }
        }

        return { items: loadedAwards, ok };
    }

    deleteAward(id: string, options?: RequestOptions) {
        return this.delete(id, options);
    }
}

export const awardEnrichmentApi = new AwardEnrichmentApi(httpClient);
